import { z } from 'zod'

import {
  FeedbackAccountAgeBandChoice,
  FeedbackDeviceType,
  SubscriptionTier,
} from '@gto/api-client/admin/react-query'
import { SUPPORTED_LANGUAGES } from '@gto/i18n/languages'

const DAY_PATTERN = /^\d{4}-\d{2}-\d{2}$/

const dayParam = z.string().regex(DAY_PATTERN).optional().catch(undefined)

/**
 * The filter row is the URL, so staff can send a colleague the exact view they
 * read. The keys are the API's own names. A value the API would refuse is
 * dropped, and the page then shows the unfiltered view instead of an error.
 *
 * An absent `version` means "the current version". The trend reads that absence
 * as "every version", which is the only view where its line can break at a
 * version change.
 */
export const feedbackResultsSearchSchema = z.object({
  version: z.coerce.number().int().positive().optional().catch(undefined),
  date_from: dayParam,
  date_to: dayParam,
  plan_tier: z.enum(SubscriptionTier).optional().catch(undefined),
  account_age: z.enum(FeedbackAccountAgeBandChoice).optional().catch(undefined),
  language: z.enum(SUPPORTED_LANGUAGES).optional().catch(undefined),
  device: z.enum(FeedbackDeviceType).optional().catch(undefined),
})

export type FeedbackResultsSearch = z.infer<typeof feedbackResultsSearchSchema>
